import { render, staticRenderFns } from "./AddEditRole.vue?vue&type=template&id=669392d1&scoped=true"
import script from "./AddEditRole.vue?vue&type=script&lang=js"
export * from "./AddEditRole.vue?vue&type=script&lang=js"
import style0 from "./AddEditRole.vue?vue&type=style&index=0&id=669392d1&prod&lang=css"
import style1 from "./AddEditRole.vue?vue&type=style&index=1&id=669392d1&prod&lang=scss&scoped=true"
import style2 from "./AddEditRole.vue?vue&type=style&index=2&id=669392d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669392d1",
  null
  
)

export default component.exports